import { WebWorkerMessageHandler } from 'src/app/modules/core/web-workers/web-worker-message-handler.model';
import { LoggerService } from 'src/app/modules/core/services/logger/logger.service';
import { Logger } from 'src/app/modules/core/services/logger/logger.model';
import { Store } from '@ngrx/store';
import * as fromComm from 'src/app/modules/communications/store/communications';

export class UpdateMassNotificationHandler implements WebWorkerMessageHandler {
  private logger: Logger;

  public constructor(private store$: Store, private loggerService: LoggerService) {
    this.logger = loggerService.getLogger('WebworkerClient.UpdateMassNotificationHandler');
  }

  processMessage(payload: any): void {
    const stats = payload;

    this.logger.logInfo('Received new message in browser', { stats });

    this.store$.dispatch(fromComm.setMassNotificationStatsUpdated({ stats }));
  }
}
